import { filter } from 'lodash';
// import { Icon } from '@iconify/react';
// import { sentenceCase } from 'change-case';
import { useState, useEffect, useCallback, useMemo } from 'react';
// import plusFill from '@iconify/icons-eva/plus-fill';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// // material
// import { styled } from '@mui/material/styles';
import {
  Box,
  Card,
  Table,
  Button,
  TableRow,
  // Checkbox,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Divider,
  Chip
} from '@mui/material';
// redux
import { useDispatch, useSelector } from '../../../redux/store';
import { setEnviosList } from '../../../redux/slices/dagpacket';
// utils
// eslint-disable-next-line
import { fDate, fDateTime } from '../../../utils/formatTime';
import { fCurrency } from '../../../utils/formatNumber';
// routes
// import { PATH_DASHBOARD } from '../../../routes/paths';
// hooks
import useSettings from '../../../hooks/useSettings';
// components
import Page from '../../Page';
// import Label from '../../Label';
import Scrollbar from '../../Scrollbar';
import SearchNotFound from '../../SearchNotFound';
// import HeaderBreadcrumbs from '../../HeaderBreadcrumbs';
import { ProductListHead, Label } from '../e-commerce/product-list';
import EnvioListToolbar from './EnvioListToolbar';
// import { Icon } from '@iconify/react';
import { firestore } from '../../../contexts/FirebaseContext';
import CartCheckoutComplete from '../cotenvio/checkout/CartCheckoutComplete';
import { clipPaymentConfirm, getConvertCompras, hacerEnvioRedpack } from '../../../_apis_/dagpacket';
import useAuth from '../../../hooks/useAuth';
import PaqueteriaAvatar from './general/PaqueteriaAvatar';
import { Icon } from '@iconify/react';
import { startDate } from '../../../constants/estartDate';
import useAuthUsers from '../../../hooks/useAuthUsers';
import useUserRole from '../../../hooks/useUserRole';
import { useFilterByDate } from '../../../hooks/useFilterByDate';
import useHandleFiltroFecha from '../../../hooks/useHandleFiltroFecha';
import { findUsersByHostUser } from '../../../utils/findUsersByHostUser';

const TABLE_HEAD_ADMIN = [
  { id: 'id', label: '#', alignRight: false },
  { id: 'rate_provider', label: 'Paqueteria', alignRight: false },
  { id: 'created_at', label: 'Fecha', alignRight: false },
  { id: 'shippingValue', label: 'Precio', alignRight: true },
  { id: 'costo', label: 'Costo', alignRight: true },
  { id: 'utilidad', label: 'Utilidad', alignRight: true },
  { id: 'city_from', label: 'Origen', alignRight: true },
  { id: 'city_to', label: 'Destino', alignRight: true },
  { id: 'state', label: 'Estado de pago', alignRight: true },
  { id: 'status', label: 'Estado de envio', alignRight: true },
  { id: '' }
];
const TABLE_HEAD_LICEN = [
  { id: 'id', label: '#', alignRight: false },
  { id: 'rate_provider', label: 'Paqueteria', alignRight: false },
  { id: 'created_at', label: 'Fecha', alignRight: false },
  { id: 'shippingValue', label: 'Precio', alignRight: true },
  { id: 'costo', label: 'Costo', alignRight: true },
  { id: 'city_from', label: 'Origen', alignRight: true },
  { id: 'city_to', label: 'Destino', alignRight: true },
  { id: 'state', label: 'Estado de pago', alignRight: true },
  { id: 'status', label: 'Estado de envio', alignRight: true },
  { id: '' }
];

const TABLE_HEAD_NORMAL = [
  { id: 'id', label: '#', alignRight: false },
  { id: 'rate_provider', label: 'Paqueteria', alignRight: false },
  { id: 'created_at', label: 'Fecha', alignRight: false },
  { id: 'shippingValue', label: 'Precio', alignRight: true },
  { id: 'city_from', label: 'Origen', alignRight: true },
  { id: 'city_to', label: 'Destino', alignRight: true },
  { id: 'state', label: 'Estado de pago', alignRight: true },
  { id: 'status', label: 'Estado de envio', alignRight: true },
  { id: '' }
];

const selectTableHead = (rolUser) => {
  switch (rolUser) {
    case 'ADMIN':
      return TABLE_HEAD_ADMIN;

    case 'LICENCIATARIO':
      return TABLE_HEAD_LICEN;

    default:
      return TABLE_HEAD_NORMAL;
  }
};

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  if (query) {
    return filter(
      array,
      (_product) => _product?.refenceValue?.toString().toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }

  return stabilizedThis.map((el) => el[0]);
}

function calcNewCost(value, percent) {
  const xpercent = value * (percent / 100);
  return value + xpercent;
}
// ----------------------------------------------------------------------

export default function ListaEnvio() {
  const { themeStretch } = useSettings();
  // const theme = useTheme();
  const dispatch = useDispatch();
  const { envios, userList } = useSelector((state) => state.dagpacket);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [orderBy, setOrderBy] = useState('createdAt');
  const [statusEnvioSelected, setStatusEnvioSelected] = useState(['LABEL_CREATED']);

  const admin = 'ADMIN';
  const licen = 'LICENCIATARIO';

  const [fecha, setFecha] = useState('');
  // const { search } = useLocation();
  const { user } = useAuth();
  const { currentUser } = useAuthUsers();
  const { actualRol } = useUserRole();

  const combinedUsers = useMemo(() => findUsersByHostUser(userList, currentUser.id), [userList]);
  // const combinedUsers = useMemo(() => findUsersByHostUser(userList, currentUserId), [userList]);
  const combinedUserIds = useMemo(() => combinedUsers.map((user) => user.id), [combinedUsers]);

  // const TABLE_HEAD = selectTableHead(actualRol.userType);
  const TABLE_HEAD = TABLE_HEAD_NORMAL;

  useEffect(() => {
    async function getPaqueterias() {
      await firestore
        .collection('cotizaciones')
        .where('user_id', '==', user.id)
        // .where('created_at', '>', startDate)
        .orderBy('created_at', 'desc')
        // .limit(200)
        .onSnapshot((snapshot) => {
          const envios = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
            refenceValue:
              doc.data().status === 'CREATED'
                ? `${doc.data()?.object_id} - ${doc.data()?.tracking_code} - ${doc.data()?.trackingNumber} - ${
                    doc.data().label_code
                  } - ${doc.data()?.purchase_id}`
                : doc.data()?.object_id
          }));
          // console.log(envios);
          dispatch(setEnviosList(envios));
        });
    }
    getPaqueterias();
    // dispatch(getProducts());
  }, [dispatch, user]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = envios.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - envios.length) : 0;

  const filterDate = (data, date) => {
    if (date.length > 0) {
      // const asd = data.map((item) => console.log(item.created_at.toDate().toISOString().substring(0, 10)));
      return data.filter((item) => item.created_at.toDate().toISOString().substring(0, 10) === date);
      // return data;
    }
    return data;
  };

  const filterStatus = (data, selectedStatuses) => {
    if (selectedStatuses.length === 0) {
      return data;
    }

    const hasStatus = (status) => selectedStatuses.includes(status);

    return data.filter((item) => {
      if (hasStatus('QUOTE') && (item.status === 'QUOTE' || item.status === 'PURCHASE')) {
        return true;
      }
      if (hasStatus('LABEL_CREATED') && (item.status === 'LABEL_CREATED' || item.status === 'CREATED')) {
        return true;
      }
      if (hasStatus('PENDIENTE-CANCELACION') && item.state === 'PENDIENTE-CANCELACION') {
        return true;
      }
      if (hasStatus('CANCELADO') && item.status === 'CANCELADO') {
        return true;
      }

      return false;
    });
  };
  const filteredByStatus = filterStatus(envios, statusEnvioSelected);

  const filteredByDate = filterDate(filteredByStatus, fecha);

  const filteredProducts = applySortFilter(filteredByDate, getComparator(order, orderBy), filterName);

  const { handleDesde, handleHasta, handleResetFechas, hasta, desde } = useHandleFiltroFecha();
  const isProductNotFound = filteredProducts.length === 0;
  // collection_status=approved
  // status=approved
  const { filteredData } = useFilterByDate(filteredProducts, desde, hasta, 'updated_at');
  const handleStatus = (selectedStatuses) => {
    console.log({ selectedStatuses });
    setStatusEnvioSelected(selectedStatuses);
  };

  // console.log({ filteredData });

  return (
    <Page title="Paquetes - Lista de Envios">
      {/* <Container maxWidth={themeStretch ? false : 'lg'}> */}
      {/* <CartCheckoutComplete open={openComplete} setOpen={setOpenComplete} /> */}
      <Card>
        <Box display="flex" justifyContent="center" sx={{ margin: '15px 0' }}>
          <Typography component="h2" variant="h4">
            Envios
          </Typography>
        </Box>
        <Divider />
        {/* <RouterLink to="/cotizaciones/new">Nueva Cotizacion</RouterLink> */}
        <Box padding="15px">
          <Button variant="contained" fullWidth>
            <RouterLink
              to="/dashboard/cotizaciones/new"
              style={{
                color: '#fff',
                textDecoration: 'none',
                padding: '5px 10px',
                width: '100%',
                height: '100%',
                textTransform: 'initial'
              }}
            >
              Nueva cotizacion
            </RouterLink>
          </Button>
        </Box>
        <EnvioListToolbar
          numSelected={selected.length}
          filterName={filterName}
          onFilterName={handleFilterByName}
          date={fecha}
          setDate={setFecha}
          handleStatus={handleStatus}
          onDesdeDate={handleDesde}
          onHastaDate={handleHasta}
          hasFilterDate
          userIds={combinedUserIds}
          desde={desde}
          hasta={hasta}
          handleResetFechas={handleResetFechas}
          statusEnvioSelected={statusEnvioSelected}
        />

        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <ProductListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={envios.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                onSelectAllClick={handleSelectAllClick}
                checkbox={false}
              />
              <TableBody>
                {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                  const {
                    id,
                    created_at,
                    shippingValue,
                    costo,
                    utilidad,
                    city_from,
                    city_to,
                    state,
                    rate_provider,
                    provider,
                    trackingNumber,
                    purchase_id,
                    tracking_code,
                    label_code,
                    status,
                    payment_id,
                    oneRequest
                  } = row;

                  const createDate = created_at.value
                    ? fDateTime(new Date(created_at.value))
                    : fDateTime(created_at.toDate());

                  const isItemSelected = selected.indexOf(id) !== -1;

                  return (
                    <TableRow
                      hover
                      key={id}
                      tabIndex={-1}
                      role="checkbox"
                      selected={isItemSelected}
                      aria-checked={isItemSelected}
                    >
                      <TableCell component="th" scope="row" padding="none">
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                          }}
                        >
                          {status === 'CREATED' ? (
                            <>
                              <Typography fontSize="11px">
                                Dagpacket Code:{' '}
                                <Typography fontSize="11px" component="span" variant="subtitle2">
                                  {id}
                                </Typography>
                              </Typography>
                              <Typography fontSize="11px">
                                Track N°:{' '}
                                <Typography fontSize="11px" component="span" variant="subtitle2">
                                  {tracking_code || trackingNumber}
                                </Typography>
                              </Typography>
                              {/* <Typography fontSize="11px">
                                Comp. ID:{' '}
                                <Typography fontSize="11px" component="span" variant="subtitle2">
                                  {purchase_id}
                                </Typography>{' '}
                              </Typography>{' '} */}
                            </>
                          ) : (
                            <Typography fontSize="13px">{id}</Typography>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <PaqueteriaAvatar size="small" rate_provider={rate_provider} />
                        <Typography variant="subtitle2" fontSize="13px">
                          {rate_provider}
                        </Typography>
                      </TableCell>
                      <TableCell style={{ minWidth: 160 }}>{createDate}</TableCell>
                      <TableCell align="right">{fCurrency(shippingValue)}</TableCell>
                      {/* {licen === actualRol.userType && (
                        <>
                          <TableCell align="right">{fCurrency(calcNewCost(costo, 5))}</TableCell>
                        </>
                      )}
                      {admin === actualRol.userType && (
                        <>
                          <TableCell align="right">{fCurrency(costo)}</TableCell>
                          <TableCell align="right">{fCurrency(utilidad)}</TableCell>
                        </>
                      )} */}
                      <TableCell align="right">{city_from}</TableCell>
                      <TableCell align="right">{city_to}</TableCell>
                      <StatusTableCell data={row} />
                      {/* <TableCell align="right">
                          {state && <Chip sx={{ fontSize: '10px' }} label={state} size="small" color="info" />}
                        </TableCell> */}

                      <TableCell align="right">{status && <Label text={status} />}</TableCell>

                      <TableCell align="right">
                        <Button
                          variant="contained"
                          // sx={{ padding: '0px' }}
                          size="small"
                          endIcon={<Icon icon="eva:file-text-fill" />}
                        >
                          <RouterLink
                            to={`${id}?payment_id=${payment_id}&oneRequest=${oneRequest}&paqueteria=${rate_provider}&provider=${provider}&codigo=${trackingNumber}&tracking_code=${tracking_code}`}
                            style={{ color: '#fff', textDecoration: 'none' }}
                          >
                            Detalle
                          </RouterLink>
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isProductNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6}>
                      <Box sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={envios.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
      {/* </Container> */}
    </Page>
  );
}

function StatusTableCell({ data }) {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const { state, payment_source, payment_id } = data;

  const getStatusClip = useCallback(() => {
    setLoading(true);
    clipPaymentConfirm(payment_id)
      .then((res) => {
        console.log('clip message', res);
        setLoading(false);
        setMessage('pagado clip');
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, [payment_id]);

  useEffect(() => {
    if (payment_source === 'CLIP') {
      getStatusClip();
    }
    setMessage(state || '-');
  }, [payment_source, getStatusClip, state]);
  // console.log(data);
  return (
    <TableCell align="right">
      {/* {state && <Chip sx={{ fontSize: '10px' }} label={state} size="small" color="info" />} */}
      {loading ? 'loading...' : <Chip sx={{ fontSize: '10px' }} label={message} size="small" color="info" />}
    </TableCell>
  );
}
